/**
 * Klaviyo BIS Fallback Button
 * Shows a basic "Notify Me" button if Klaviyo fails to inject within timeout
 */

(function() {
  'use strict';
  
  try {
    
  const FALLBACK_TIMEOUT = 3000; // Wait 3 seconds for Klaviyo
  const FALLBACK_BUTTON_HTML = `
    <button 
      class="btn btn--tertiary btn--load !w-full klaviyo-bis-fallback-btn"
      type="button"
      onclick="alert('Please contact us at support@seattlecoffeegear.com to be notified when this item is back in stock.')"
    >
      <div class="btn__content">
        Notify Me When Available
      </div>
    </button>
  `;
  
  function checkAndInjectFallback() {
    const triggers = document.querySelectorAll('.klaviyo-bis-trigger');
    
    triggers.forEach(trigger => {
      // Skip if:
      // - Not visible
      // - Already has Klaviyo button
      // - Already has fallback
      const isVisible = trigger.offsetParent !== null;
      const hasKlaviyoButton = trigger.querySelector('.klaviyo-bis-button-container');
      const hasFallback = trigger.querySelector('.klaviyo-bis-fallback-btn');
      
      if (!isVisible || hasKlaviyoButton || hasFallback) {
        return;
      }
      
      // Check if Klaviyo SDK loaded but didn't inject
      const klaviyoLoaded = window._klOnsite !== undefined;
      
      if (klaviyoLoaded) {
        // Klaviyo is loaded but hasn't injected - try to trigger it one more time
        console.warn('Klaviyo loaded but button not injected, attempting refresh...');
        if (typeof window.__scgInitKlaviyoBIS === 'function') {
          window.__scgInitKlaviyoBIS();
        }
        
        // Give it one more second
        setTimeout(() => {
          const stillNoButton = !trigger.querySelector('.klaviyo-bis-button-container');
          if (stillNoButton && trigger.offsetParent !== null) {
            console.warn('Klaviyo failed to inject button, showing fallback');
            injectFallbackButton(trigger);
          }
        }, 1000);
      } else {
        // Klaviyo SDK never loaded - show fallback immediately
        console.warn('Klaviyo SDK not loaded, showing fallback button');
        injectFallbackButton(trigger);
      }
    });
  }
  
  function injectFallbackButton(trigger) {
    // Create a container similar to what Klaviyo would inject
    const container = document.createElement('div');
    container.className = 'klaviyo-bis-fallback-container';
    container.innerHTML = FALLBACK_BUTTON_HTML;
    
    // Inject at the beginning of the trigger
    trigger.insertBefore(container, trigger.firstChild);
    
    // Log for debugging
    // console.log('Fallback BIS button injected for product:', trigger.dataset.product);
  }
  
  // Watch for triggers to become visible
  function observeTriggers() {
    const observer = new MutationObserver(() => {
      const triggers = document.querySelectorAll('.klaviyo-bis-trigger');
      triggers.forEach(trigger => {
        if (trigger.offsetParent !== null && !trigger.dataset.fallbackChecked) {
          trigger.dataset.fallbackChecked = 'true';
          setTimeout(() => checkAndInjectFallback(), FALLBACK_TIMEOUT);
        }
      });
    });
    
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      subtree: true
    });
  }
  
  // Initialize
  function init() {
    // Check immediately for any visible triggers
    const visibleTriggers = Array.from(document.querySelectorAll('.klaviyo-bis-trigger'))
      .filter(t => t.offsetParent !== null);
    
    if (visibleTriggers.length > 0) {
      setTimeout(() => checkAndInjectFallback(), FALLBACK_TIMEOUT);
    }
    
    // Watch for triggers that become visible later
    observeTriggers();
  }
  
  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  } catch (error) {
    console.error('Klaviyo BIS fallback script error:', error);
  }
  
})();
